const GOLD_ACTION_TYPES = {
  LOAD_GOLD: 'gold/LOAD_GOLD',
};

export default GOLD_ACTION_TYPES;
